import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export type KeysOfType<T, V> = {
  [K in keyof T]: Extract<T[K], V> extends never ? never : K;
}[keyof T];

export const debounce = (func: (...args: any[]) => void, delay: number) => {
  let timeoutId: NodeJS.Timeout;
  return (...args: any[]) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func(...args), delay);
  };
};

export interface FormatCurrencyOptions {
  currency?: string;
  locale?: string;
  notation?: "standard" | "scientific" | "engineering" | "compact";
}

export function formatCurrency(
  value: number | undefined | null,
  options: FormatCurrencyOptions = {}
): string {
  if (value === undefined || value === null) return "-";

  const { currency = "EUR", locale = "nl-NL", notation = "standard" } = options;

  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
    notation,
  }).format(value);
}

export function formatNumber(value: number | null | undefined): string {
  if (value == null) return "—";
  return value.toLocaleString("nl-NL");
}

export const orderSorting = (a: { order: number }, b: { order: number }) => {
    if (a.order == b.order)
      return 0;
    if (a.order > b.order)
      return 1;
    return -1;
  }
